import { useMemo } from 'react';
import { Dictionary } from 'lodash';
import { TimeSeries } from '../../../models';
import { ChartGroups } from './types';

const getDataGroups = (tagIds: string[], timeSeries: Dictionary<TimeSeries>): ChartGroups => {
  const groups: ChartGroups = {
    chart: {},
    bitfield: {},
    enum: {},
  };

  tagIds.forEach((tagId, i) => {
    const series = timeSeries[tagId];
    const unit = series.unit;
    let chartGroup: keyof ChartGroups = 'chart';

    if (series.dataType === 'Bitfield') {
      chartGroup = 'bitfield';
    }
    if (series.dataType === 'Enum') {
      chartGroup = 'enum';
    }

    groups[chartGroup][unit] = groups[chartGroup][unit] || [];

    groups[chartGroup][unit].push({
      key: series.tagId,
      meanings: series.tag.meanings || [],
      values: series.points
        .filter((p) => p.value !== null)
        .map((p) => ({ x: p.time, y: p.value as number })),
    });
  });

  return groups;
};

export function useDataGroups(tagIds: string[], snapshots: Dictionary<TimeSeries>) {
  const lineGroups = useMemo(() => getDataGroups(tagIds, snapshots), [tagIds, snapshots]);

  return lineGroups;
}
